import script from "./PersonAddressCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonAddressCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonAddressCardComponent.vue?vue&type=style&index=0&id=5b196e19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b196e19"]])

export default __exports__